<nav class="border-common-base flex h-full flex-col border-x">
  <div
    class="text-common-base border-common-base flex h-[3.5rem] w-full shrink-0 items-center gap-2 border-y p-4"
  >
    <svg-icon src="assets/icons/general/calendar.svg" />
    <span class="font-semibold">{{ isoWeekService.currentWeek }}</span>
  </div>

  <ul class="flex w-full grow flex-col gap-2 overflow-auto p-2">
    @for (nav of navigationConfig(); track $index) {
      @if (navService.isCategory(nav)) {
        <ng-container *agHasPermissionAny="nav.categoryPermissions">
          <li class="mb-2 mt-4 px-2">
            <span
              class="typography-overlines-small uppercase text-text-common-base"
            >
              {{ nav.categoryLabel }}
            </span>
          </li>

          @for (child of nav.categoryItems; track child.label) {
            <ng-container
              *ngTemplateOutlet="navNodeRenderer; context: { $implicit: child }"
            />
          }
        </ng-container>
      } @else {
        <ng-container
          *ngTemplateOutlet="navNodeRenderer; context: { $implicit: nav }"
        />
      }
    }
  </ul>

  <div class="mt-auto grid shrink-0 place-items-center border-t px-2 py-4">
    <svg-icon src="assets/icons/brand/logo-horizontal-primary-default.svg" />
  </div>
</nav>

<ng-template #navNodeRenderer let-nav>
  @if (navService.isNavList(nav)) {
    <ng-container *agHasPermissionAny="nav.permissions">
      <li>
        <app-navigation-item [navList]="nav" />

        @if (navService.isSelectedList(nav.label)) {
          <ul class="my-2 !ml-8 flex flex-col">
            @for (navItem of nav.items; track navItem) {
              <ng-container *agHasPermission="navItem.permission">
                <li>
                  <app-navigation-item [navItem]="navItem" [isNested]="true" />
                </li>
              </ng-container>
            }
          </ul>
        }
      </li>
    </ng-container>
  }

  @if (navService.isNavItem(nav)) {
    <ng-container *agHasPermission="nav.permission">
      <li>
        <app-navigation-item [navItem]="nav" [isNested]="false" />
      </li>
    </ng-container>
  }
</ng-template>
